import React from 'react'
import { bem } from '@argos/utils'

import LoadingWheel from '@argos/loading-wheel'

const cn = bem({ prefix: 'lc-', block: 'disconnect' })

const message = 'We’re struggling with a connection'

const Disconnect = () => (
  <div className={`${cn()} lc-controls__form lc-controls__form--with-seperator text-center`}>
    <div role='alert'>
      {message}
      {<LoadingWheel contained noMask />}
      <div role='alert' className={cn('alert')}>
        Reconnecting...
      </div>
    </div>
  </div>
)

export default Disconnect
